export function htmlFeeAnother() {
  return (
    <>
      <hr />
      <h5>Outras Taxas e Impostos</h5>
      <p>
        Em operações de rifas online, algumas taxas e impostos são aplicados por
        entidades externas ou são obrigatórios por legislação. Esses valores
        podem variar conforme a região, o tipo de premiação e as regulamentações
        locais. Abaixo estão os principais tipos de taxas e impostos que podem
        ser aplicados:
      </p>

      <h4>1. Impostos sobre Prêmios e Rifas</h4>
      <p>
        Dependendo da legislação municipal, estadual ou federal, as rifas podem
        estar sujeitas a diferentes tributações, como:
      </p>
      <ul>
        <li>
          <strong>
            Imposto sobre Circulação de Mercadorias e Serviços (ICMS):
          </strong>{" "}
          Aplicável em alguns estados para comercialização de bilhetes.
        </li>
        <li>
          <strong>Imposto sobre Serviços (ISS):</strong> Cobrado por alguns
          municípios sobre a intermediação da plataforma.
        </li>
        <li>
          <strong>Imposto de Renda sobre Prêmios:</strong> Prêmios de alto valor
          podem estar sujeitos à retenção na fonte, conforme legislação vigente.
        </li>
      </ul>

      <h4>2. Taxas Regulatórias e de Compliance</h4>
      <p>
        Para operar de forma regularizada, a plataforma pode estar sujeita a
        custos como:
      </p>
      <ul>
        <li>
          <strong>Taxas de licenciamento:</strong> Custos para operação legal
          conforme regulamentações específicas de jogos e sorteios.
        </li>
        <li>
          <strong>Taxas de auditoria:</strong> Necessárias para garantir a
          transparência e segurança dos sorteios realizados.
        </li>
        <li>
          <strong>Taxas de certificação digital:</strong> Para validação e
          segurança das transações eletrônicas.
        </li>
      </ul>

      <h4>3. Taxas Administrativas Diversas</h4>
      <p>
        Outros custos operacionais que podem ser repassados conforme a natureza
        da operação:
      </p>
      <ul>
        <li>
          <strong>Taxas de processamento especial:</strong> Para pagamentos com
          métodos específicos ou transações de alto risco.
        </li>
        <li>
          <strong>Custos de notificação e documentação:</strong> Relacionados à
          comunicação oficial com ganhadores e órgãos reguladores.
        </li>
        <li>
          <strong>Taxas de serviços terceirizados:</strong> Como validação de
          identidade, consultoria jurídica ou serviços contábeis obrigatórios.
        </li>
      </ul>

      <p>
        Essas taxas e impostos são aplicados conforme a legislação vigente e as
        condições específicas de cada operação, visando garantir a legalidade e
        transparência de todas as transações realizadas em nossa plataforma.
      </p>
    </>
  );
}
